import { render } from "./ConfirmOrderModal.vue?vue&type=template&id=b8ba09e8"
import script from "./ConfirmOrderModal.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_5ac5815b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__